"use strict";
// report-types.d.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportFormat = exports.ReportType = exports.TimePeriod = void 0;
// Time period enum
var TimePeriod;
(function (TimePeriod) {
    TimePeriod["DAILY"] = "DAILY";
    TimePeriod["WEEKLY"] = "WEEKLY";
    TimePeriod["MONTHLY"] = "MONTHLY";
    TimePeriod["QUARTERLY"] = "QUARTERLY";
    TimePeriod["YEARLY"] = "YEARLY";
})(TimePeriod || (exports.TimePeriod = TimePeriod = {}));
var ReportType;
(function (ReportType) {
    ReportType["CUSTOMER_AGING"] = "CUSTOMER_AGING";
    ReportType["REVENUE"] = "REVENUE";
    ReportType["EXPENSES"] = "EXPENSES";
    ReportType["PROFIT_LOSS"] = "PROFIT_LOSS";
    ReportType["CASH_FLOW"] = "CASH_FLOW";
    ReportType["OCCUPANCY_REVENUE"] = "OCCUPANCY_REVENUE";
})(ReportType || (exports.ReportType = ReportType = {}));
// Export format
var ExportFormat;
(function (ExportFormat) {
    ExportFormat["CSV"] = "CSV";
    ExportFormat["PDF"] = "PDF";
    ExportFormat["EXCEL"] = "EXCEL";
})(ExportFormat || (exports.ExportFormat = ExportFormat = {}));
